import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';
import { Checkbox, FilterPanel, StyledMargin } from '@dreryk/react-components';

import {
   WaitlistFilterPanelFormBean,
   WaitlistFilterPanelSearchParam,
   WaitlistFilterPanelStorageKey,
} from '../../WaitlistFilterPanel.types';
import { translationKeys } from '../../../translations';

import { urgentCodec, urgentDeselectorsPropsMapper } from './UrgentController.utils';

type ReservationPreferenceControllerProps = {
   registerController: BindingCreator<WaitlistFilterPanelFormBean, 'urgent'>;
};

export const UrgentController = (props: ReservationPreferenceControllerProps): ReactElement => {
   return (
      <FilterPanel.Controller<WaitlistFilterPanelFormBean, 'urgent'>
         name={'urgent'}
         searchParam={WaitlistFilterPanelSearchParam.URGENT}
         storageKey={WaitlistFilterPanelStorageKey.URGENT}
         codec={urgentCodec}
         chipsLabel={translationKeys.category}
         getDeselectorsProps={urgentDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledMargin top={16}>
               <Checkbox
                  testId={'urgent'}
                  controller={props.registerController('urgent')}
                  label={translationKeys.showUrgentOnly}
                  onSelectionChange={applyFilter}
               />
            </StyledMargin>
         )}
      </FilterPanel.Controller>
   );
};
